import notification from "../../commons/notification";

const Triggers = [
  { id: "change", name: "changed" },
  { id: "target", name: "due" },
  { id: "execute", name: "performing" },
  { id: "changeFrom", name: "changed from" },
  { id: "changeTo", name: "changed to" }
];

const getEventInfo = (event) => {
  try {
    const channel = event && event.channel ? notification.channels.find(x => x.id === event.channel) : null;
    const getIcon = () => {
      // Studio schedule (docs/scheduling-routine-automation-proposal.md): the clock tells it apart
      if (event.type === 'routine')
        return ["fas", "clock"];
      else if (event.actionType === 'advanced')
        return ["fas", "scroll"];
      else if (event.actionType === 'notification')
        return channel && channel.icon || ["far", "bell"];
      else
        return ["fas", "bolt"];
    }
    const getLabel = () => {
      if (event.name)
        return event.name;
      else if (event.description)
        return event.description;
      else if (event.type === 'routine')
        return 'Schedule';
      else if (event.actionType === 'advanced')
        return 'Advanced';
      else if (event.actionType === 'automation')
        return 'Automation';
      else if (event.actionType === 'notification')
        return channel && channel.name || 'Notification';
      else
        return '(undefined)';
    }
    return { icon: getIcon(), label: getLabel() };
  } catch (err) {
    console.warn('EventInfo', err);
    return { label: '(undefined)' };
  }
}

const getEventType = (event, { informationType } = {}) => {
  try {
    switch (event.type) {
      case "routine":
        return "schedule";
      case "vector":
        return "vector";
      case "activities":
        return "activityConsole";
      case "standardActivities":
        return "standardConsole";
      case "states":
        return "stateConsole";
      case "state":
        return "state";
      case "activity":
        return "activity";
      case "standardActivity":
        return "standardActivity";
      case "information":
        if (!event.item)
          return "informationConsole";
        else
          return informationType &&
            (informationType == 5 || informationType == 6) ?
            "due" :
            "information";
    }
  } catch (err) {
    console.warn('EventType', err);
  }
}

export default {
  Triggers: Triggers,
  getEventInfo: getEventInfo,
  getEventType: getEventType
}